import { render, staticRenderFns } from "./RigheDistintaList.vue?vue&type=template&id=4308e214&scoped=true"
import script from "./RigheDistintaList.vue?vue&type=script&lang=ts"
export * from "./RigheDistintaList.vue?vue&type=script&lang=ts"
import style0 from "./RigheDistintaList.vue?vue&type=style&index=0&id=4308e214&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4308e214",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4308e214')) {
      api.createRecord('4308e214', component.options)
    } else {
      api.reload('4308e214', component.options)
    }
    module.hot.accept("./RigheDistintaList.vue?vue&type=template&id=4308e214&scoped=true", function () {
      api.rerender('4308e214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/consumi/RigheDistintaList.vue"
export default component.exports